import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ExcelIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M2 1V7H4V3H20V18C20 19.6543 18.6543 21 17 21H4V17H2V23H17C19.7568 23 22 20.7568 22 18V1H2Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M19 13.1202C19 14.3358 18.0883 15.2015 16.4583 15.2015C15.0401 15.2015 13.8521 14.5568 13.8797 12.89H15.1598C15.1506 13.7648 15.6847 14.1056 16.4859 14.1056C17.1766 14.1056 17.7199 13.9214 17.7199 13.2952C17.7199 12.6966 17.3055 12.5492 16.1636 12.2085C14.9848 11.877 14.0363 11.4718 14.0363 10.2562C14.0363 8.93007 15.1506 8.31306 16.3662 8.31306C17.6463 8.31306 18.8434 8.90244 18.8527 10.4219H17.5726C17.5265 9.61154 16.974 9.38132 16.3386 9.38132C15.8321 9.38132 15.3256 9.55629 15.3256 10.118C15.3256 10.6153 15.6018 10.7535 16.9464 11.1863C18.0699 11.5362 19 11.8954 19 13.1202Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M8.7825 15.188H13.0187V13.9816H10.0994V8.60353H8.7825V15.188Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M7.92145 15.2014L5.72969 11.7757L7.74648 8.62614H6.29144L4.98375 10.8271L3.71289 8.62614H2.16576L4.20098 11.7757L2 15.2014H3.50108L4.92849 12.8347L6.33749 15.2014H7.92145Z",
    fill: "currentColor"
  }));
}